import { render, staticRenderFns } from "./hobby.vue?vue&type=template&id=4fe87df2&scoped=true&"
import script from "./hobby.vue?vue&type=script&lang=js&"
export * from "./hobby.vue?vue&type=script&lang=js&"
import style0 from "./hobby.vue?vue&type=style&index=0&id=4fe87df2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe87df2",
  null
  
)

export default component.exports